import React from 'react'
import moment from 'moment/moment'
import { get } from 'lodash'
import '../../styles/scss/components/equote-preview-package-outline.scss'
import EQuotePackageSocialMedia from './EQuotePackageSocialMedia'

import printIcon from '../../assets/icons/print-button.svg'
import EQuotePackageOutlineLandProgram from './EQuotePackageOutlineLandProgram'
import TaxLine from '../TaxLine'
import Price from '../Price'

function hasImage(currentBrand) {
  return (
    currentBrand &&
    currentBrand.badge_dark &&
    currentBrand.badge_dark.sizes &&
    currentBrand.badge_dark.sizes['agency-logo']
  )
}

const EQuotePreviewPackageOutline = props => {
  const { currentBrand, packageDetails, itinerary } = props
  const hasTourNights = packageDetails && !packageDetails.justACruise

  const captionForSharerLink = packageDetails
    ? packageDetails.description
    : null

  const imageForSharerLink = currentBrand && currentBrand.email_image.file

  if (!packageDetails) return null

  const displayTax = get(
    packageDetails,
    [
      'stateRoomData',
      'bestRate',
      packageDetails.occupancy,
      'priceInfo',
      'taxesFees'
    ],
    null
  )
  const isBundlePricing = get(
    packageDetails,
    [
      'stateRoomData',
      'bestRate',
      packageDetails.occupancy,
      'priceInfo',
      'taxesFeesIncluded'
    ],
    false
  )
  const currency = packageDetails.currency ? packageDetails.currency : 'USD'

  return (
    <div id="mid-width-alt" className="equote-preview-package-outline">
      <div className="equote-preview-package-outline--title">
        {hasImage(currentBrand) && (
          <div className="equote-preview-package-outline--title-logo">
            <img
              src={currentBrand.badge_dark.sizes['agency-logo']}
              alt={currentBrand.badge_dark.alt}
            />
          </div>
        )}
        {packageDetails && !hasTourNights && (
          <p>{packageDetails.description}</p>
        )}
      </div>
      {hasTourNights && (
        <div className="equote-preview-package-outline-tour-details">
          {Boolean(packageDetails.preTourNights) && (
            <div className="equote-preview-package-outline-tour-details--pre-cruise">
              <div className="equote-preview-package-outline-tour-details--pre-cruise-flag">
                <p>Pre-Cruise Package</p>
              </div>
              <p>
                {packageDetails.preTourName ||
                  `${packageDetails.preTourNights} ${
                    packageDetails.preTourNights === 1 ? 'Night' : 'Nights'
                  }`}
              </p>
            </div>
          )}
          <p className="equote-preview-package-outline-tour-details--primary-title">
            {packageDetails && packageDetails.description}
          </p>
        </div>
      )}

      <div className="equote-preview-package-outline--table">
        <div className={`equote-preview-package-outline--table-cell`}>
          <div
            className={`equote-preview-package-outline--table-cell--heading`}
          >
            SAILING FROM
          </div>
          <div className="equote-preview-package-outline--table-cell--info">
            {itinerary && itinerary.length ? itinerary[0].name : null}
          </div>
        </div>
        <div className={`equote-preview-package-outline--table-cell`}>
          <div
            className={`equote-preview-package-outline--table-cell--heading`}
          >
            SHIP
          </div>
          <div className="equote-preview-package-outline--table-cell--info">
            {packageDetails && packageDetails.shipName}
          </div>
        </div>
        <div className={`equote-preview-package-outline--table-cell`}>
          <div
            className={`equote-preview-package-outline--table-cell--heading`}
          >
            DEPARTURE DATE
          </div>
          <div className="equote-preview-package-outline--table-cell--info">
            {packageDetails &&
              moment(
                packageDetails.startDate || packageDetails.sailDate,
                'YYYY-MM-DD'
              ).format('MMMM DD, YYYY')}
          </div>
        </div>
        <div
          className={`equote-preview-package-outline--table-cell pricing-cell`}
        >
          <div className="equote-preview-package-outline--table-cell--heading">
            PRICING FROM
          </div>
          <div
            className={`equote-preview-package-outline--table-cell--info equote-preview-package-outline--table-cell--info-pricing${
              packageDetails &&
              packageDetails.stateRoomData &&
              packageDetails.stateRoomData.bestRate
                ? ''
                : ' u-sold-out'
            }`}
          >
            {packageDetails &&
            packageDetails.stateRoomData &&
            packageDetails.stateRoomData.bestRate ? (
              <span className="equote-preview-package-outline--table-cell--info-price-cells">
                {Object.values(packageDetails.stateRoomData.bestRate).map(
                  price => (
                    <span
                      className="equote-preview-package-outline--table-cell--info-price-cell"
                      key={price.displayName}
                    >
                      <span className="equote-preview-package-outline--table-cell--info-price-cell-name">
                        {price.displayName}
                      </span>
                      <span className="equote-preview-package-outline--table-cell--info-price-cell-price">
                        <Price
                          price={
                            packageDetails.landProgramTotalPrice
                              ? Number(
                                  packageDetails.landProgramTotalPrice +
                                    price.displayPrice
                                ).toFixed(2)
                              : price.displayPrice.toFixed(2)
                          }
                          currencySymbol={packageDetails.currencySymbol}
                          currencySymbolPlacement={
                            packageDetails.currencySymbolPlacement
                          }
                        />{' '}
                        {currency}
                      </span>

                      {/* Leaving this in case it comes back */}
                      {/*{price.leadPromoDesc && (*/}
                      {/*  <span className="equote-preview-package-outline--table-cell--info-price-cell-promo">*/}
                      {/*    {price.leadPromoDesc}*/}
                      {/*  </span>*/}
                      {/*)}*/}
                      {Boolean(
                        price.creditAmt && Number(price.creditAmt) > 0
                      ) && (
                        <span className="equote-preview-package-outline--table-cell--info-price-cell-obc">
                          ${price.creditAmt.toFixed(2)} OBC
                        </span>
                      )}
                    </span>
                  )
                )}
              </span>
            ) : (
              'Sold Out'
            )}
          </div>
        </div>
      </div>
      {Boolean(displayTax) && (
        <div
          className={`equote-preview-package-outline-fees ${
            hasTourNights && Boolean(packageDetails.postTourNights)
              ? 'border'
              : ''
          }`}
        >
          <p>
            <i>
              <TaxLine
                isBundlePricing={isBundlePricing}
                currency={
                  packageDetails.currency ? packageDetails.currency : ''
                }
                currencySymbol={packageDetails.currencySymbol || '$'}
                currencySymbolPlacement={packageDetails.currencySymbolPlacement}
                amount={displayTax.toFixed(2)}
              />
            </i>
          </p>
        </div>
      )}
      {hasTourNights && (
        <div className="equote-preview-package-outline-tour-details">
          {Boolean(packageDetails.postTourNights) && (
            <div className="equote-preview-package-outline-tour-details--post-cruise">
              <div className="equote-preview-package-outline-tour-details--post-cruise-flag">
                <p>Post-Cruise Package</p>
              </div>
              <p>
                {packageDetails.postTourName ||
                  `${packageDetails.postTourNights} ${
                    packageDetails.postTourNights === 1 ? 'Night' : 'Nights'
                  }`}
              </p>
            </div>
          )}
        </div>
      )}
      {/*Rather than map & sort I'll just be explicit
      as we can only have one pre and one post per cruise */}
      {packageDetails.landPrograms && packageDetails.landPrograms['pre'] ? (
        <EQuotePackageOutlineLandProgram
          landProgram={packageDetails.landPrograms['pre']}
          programTitle="Pre"
        />
      ) : null}
      {packageDetails.landPrograms && packageDetails.landPrograms['post'] ? (
        <EQuotePackageOutlineLandProgram
          landProgram={packageDetails.landPrograms['post']}
          programTitle="Post"
        />
      ) : null}

      <div
        className="equote-preview-package-outline-print-button"
        onClick={() => window.print()}
      >
        <div className="btn">
          <img src={printIcon} alt="print button" />
          Print
        </div>
      </div>

      <div className="equote-preview-package-outline-share">
        <EQuotePackageSocialMedia
          brandData={currentBrand}
          captionForSharerLink={captionForSharerLink}
          imageForSharerLink={imageForSharerLink}
        />
      </div>
    </div>
  )
}

export default EQuotePreviewPackageOutline
